<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<div class="personalData">
				<h1 class="h11">个人资料</h1>
				<div v-if="personalData.username">
					<el-form :model="personalData" ref="personalData">
					   	<el-form-item label="用户名:" :label-width="formLabelWidth">
					    	<span v-text="personalData.username"></span>
					    </el-form-item>
					    <el-form-item label="公司名称:" :label-width="formLabelWidth">
					    	<span v-text="personalData.company"></span>
					    </el-form-item>
					    <el-form-item label="真实姓名:" :label-width="formLabelWidth" prop="real_name">
					    	<el-input v-model="personalData.real_name" auto-complete="off"></el-input>
					    </el-form-item>
					    <el-form-item label="邮箱:" :label-width="formLabelWidth" prop="email">
					    	<el-input v-model="personalData.email" auto-complete="off"></el-input>
					    </el-form-item>
					    <!--<el-form-item label="邮箱状态:" :label-width="formLabelWidth" prop="email_status">
					    	<span v-text="ifActive22(personalData.email_status)"></span>
					    </el-form-item>
					    <el-form-item class="danger" label="注:" :label-width="formLabelWidth">
					    	<span>邮箱添加后，会收到一条激活邮件，请注意查收</span>
					    </el-form-item>-->
			        </el-form>
			        <div slot="footer" class="dialog-footer text-center">
			          <el-button type="primary" @click="savePersonalData()">保 存</el-button>
			        </div>
				</div>
			   
		        <p v-if="!personalData.username">信息获取失败</p>
		        
			    <el-dialog
			      width="30%"
			      class="text-center"
			      title="提示"
			      :visible.sync="innerUpPass"
			      append-to-body>
					<div class="userInfo">
						<p>{{innerUpPassText}}</p>
					</div>
			    </el-dialog>
			</div>
		</div>
		
	</div>
	
</template>

<script>
	let sha256=require("js-sha256").sha256;
	export default {
		mounted(){
		  	this.$nextTick(function(){
		  		
		  		this.showUserData();
		  	})
		},
		data() {
		  	return {
		  		innerUpPassText:"",
		  		innerUpPass:false,
		  		comfirNewPass:'',
		  		code:"",
		  		personalData:{},
		  		/*personalData:{
		  			username:"",
		  			real_name:"",
		  			company:"",
		  			uid:""
		  		},*/
		  		formLabelWidth:'90px'
		  	}
		},
		methods:{
			showUserData(){
				this.innerUpPass = false;
				let setNewPassParams={
		  			uid:this.getCookie('uid'),
		  			timestamp:Date.parse( new Date()),
		  		    terminalId:4
		  		};
		  		this.sign(setNewPassParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/PersonalData/PersonalData",this.$qs.stringify(setNewPassParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 && res.data.data){
		        		//console.log("验证码发送成功");
						this.personalData = res.data.data;
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
				
			},
//			保存修改,及发送验证邮件
			savePersonalData(){
				this.innerUpPass = false;
				
//				验证邮箱
//				let valiPersoParams={
//		  			username:this.getCookie('username'),
//		  			timestamp:Date.parse( new Date()),
//		  		    terminalId:1,
//		  		    email:this.personalData.email || ''
//		  		};
//		  		this.sign(valiPersoParams);
//		  		this.$ajax.post(this.$store.state.domain+"/Home/SendEmail/SendEmail",this.$qs.stringify(valiPersoParams),{
//		            emulateJSON: true
//		        }).then(res=>{
//		        	if(res.data.status==1){
//						this.$message.success("验证邮件发送成功！");
//		        		
//		        	}else if(res.data.code==10008){
//		        		this.isLogouting = true;
//					      this.delCookie('username');
//					      this.$router.push('/login/');
//					      let userInfo= { //保存用户信息
//						        real_name: '',
//						        administrators: '',
//						        username: '',
//						        token:'',
//						        uid:'',
//						        company_id:'',
//						    }
//					      this.$store.commit('updateUserInfo', userInfo); 
//		        	}else{
//		        		this.$message.error(res.data.msg);
//		        	}
//		  		});
				
				let savePersoParams={
		  			uid:this.getCookie('uid'),
		  			timestamp:Date.parse( new Date()),
		  		    terminalId:4,
		  		    real_name:this.personalData.real_name || '',
		  		    email:this.personalData.email || ''
		  		};
		  		this.sign(savePersoParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/PersonalData/Preservation",this.$qs.stringify(savePersoParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		//console.log("验证码发送成功");
		        		this.innerUpPassText = "信息修改成功！";
						this.innerUpPass = true;
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.innerUpPass = true;
		        		this.innerUpPassText = res.data.msg;
		        	}
		  		});
				
			}
			
		}
	}
</script>

<style scoped>
	.login{
		min-height: 0;
		top: 60%;
		padding-top: 20px;
	}
	.log-bg{
		height: 0px;
	}
	.log-logo{
		margin-top: 20px;
		margin-bottom: 0px;
		height: 60px;
	}
</style>


// WEBPACK FOOTER //
// src/components/personalData.vue